import Config from '@config';
import { initializeNodeSealLocationsApi } from '@gasbi/shared/common/features/nodeSealLocation';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const { nodeSealLocationApi, useGetNodeSealLocationQuery } =
  initializeNodeSealLocationsApi(Config.VITE_API_CLIENT_URL, axiosBaseQuery);
